import {Company, Benefit, MediaProfile} from '../../features/company/profile/types';
import {CompanyLocation, LanguageProfile} from '../../types/shared-types';
import {SerializeTo} from '../../utils/serializer/serialize';

type LooseCompanyProfile = {
  resourceId: string;
  name: string;
  slogan?: LanguageProfile;
  websiteUrl?: string;
  description?: LanguageProfile;
  industry?: LanguageProfile;
  employeeCountRange?: string;
  linkedinUrl?: string;
  xingUrl?: string;
  logoUrl?: string;
  headerImageUrl?: string;
  companyType?: string;
  averageEmployeeAge?: number;
  primaryCompanyLanguage?: string;
  workMode?: string;
  percOfWomenInLeadership?: number;
  percOfEmployeesAreParents?: number;
  twoFactorEnabled?: boolean;
  twoFactorEnabledAt?: string | null;
  twoFactorEnforced?: boolean;
  twoFactorEnforcedAt?: string | null;
  // Making locations and benefits optional so typescript does not complain when deleting these keys
  locations?: Array<CompanyLocation>;
  benefits?: Array<Benefit>;
  companyMediaFiles: {
    images: MediaProfile[];
    videos: MediaProfile[];
  };
};

// Removing locations and benefits from the company object to begin enforcing fetching each resource independently by
// its corresponding endpoint.
// For example locations should be fetched by `company/:id/locations`
export const companySerializer = (data?: any): Company => {
  if (!data) {
    return data;
  }
  const response = SerializeTo.CamelCase<{company: LooseCompanyProfile}>(data);
  if (response.company) {
    delete response.company.locations;
    delete response.company.benefits;

    return response.company;
  }

  return response as any;
};
